// Popup trang chủ theo khối: mỗi khối một bản ghi page-settings `popup-<khối>`, bản `popup` cũ làm dự phòng.
// Khi tách cổng tin theo hostname, chọn popup theo khối của site (xem resolveBannerAttribute trong config/banner.js).
export const POPUP_GRADES = ['1', '6', '10']

export const getPopupAttribute = grade => `popup-${grade}`
